import axios from 'axios';
import qs from 'qs';

axios.defaults.baseURL = '/api';

axios.defaults.paramsSerializer = {
  serialize: function paramsSerializer(params: Record<string, unknown>) {
    return qs.stringify(params, { arrayFormat: 'repeat', allowDots: true, skipNulls: true });
  },
};
